import React from 'react';
import _ from 'lodash';
import Select2 from 'react-select2-wrapper';
import 'react-select2-wrapper/css/select2.css';
import '../assets/css/components/render-select.css';

const renderSelect = props => {
  const { defaultValue, multiple, data, placeholder, hidden, input, label, wrapperClass, type, isNew, meta: { dirty, touched, error } } = props
  const getLabel = ()=> (label && <label onClick={e=>e.preventDefault()} htmlFor={input.id || input.name}>{label}</label>)
  const isDirty = ()=> dirty && !isNew

  return(
    <div className={`${type} ${wrapperClass} input select-form-group form-group form-group-default`}>
      {getLabel()}
      <Select2 defaultValue={defaultValue} multiple={multiple} data={data} {...input} name={input.name} className={`form-control no-box-shadow`} id={input.name} />
    </div>
  )
}

export default renderSelect;
